module.exports = __webpack_public_path__ + "static/img/interpretive-graphic-design01.8c30b6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/graphic-design/interpretive-graphic-design01.jpg
// module id = 1007
// module chunks = 0